// @flow
/** @jsx isolateComponent */
import pluralizer from 'pluralize';

import {
  GridLayout,
  Icon,
  StaticImage,
  Text,
  TruncatedText,
} from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';

import type { SharedItemType } from '@zapier/team/src/types';

type Props = {
  isSharedWithAll: boolean,
  item: SharedItemType,
  shareCount: number,
};

const renderImage = (props: Props) => {
  if (props.item.imageUrl) {
    // item has an image url so use a StaticImage to display
    return (
      <StaticImage
        alt={props.item.name}
        height={32}
        src={props.item.imageUrl}
        width={32}
      />
    );
  }
  if (props.item.image) {
    // Item has an image defined (this will be a react Node) so just return it
    return props.item.image;
  }

  // Item has an icon defined so use Icon to display it with `zapier-logo` as a fallback
  return (
    <Icon color="avatar" name={props.item.icon || 'zapier-logo'} size={32} />
  );
};

const renderShareMessage = (props: Props) => {
  if (props.item.isShared) {
    if (props.isSharedWithAll) {
      return 'Shared with Everyone';
    }
    return `Shared - ${props.shareCount} ${pluralizer(
      'Member',
      props.shareCount
    )}`;
  }
  return 'Private';
};

const ShareDetails = (props: Props) => {
  return (
    <GridLayout alignItems="center" columns="32px 1fr" gap={10}>
      {renderImage(props)}
      <GridLayout rows="23px 1fr">
        <TruncatedText>
          <Text type="body-large-strong">{props.item.name}</Text>
        </TruncatedText>
        <Text color="batmobile" type="fine">
          {renderShareMessage(props)}
        </Text>
      </GridLayout>
    </GridLayout>
  );
};

export default ShareDetails;
